﻿

export function initRenteherzieningPage() {
    var dialogElem = document.getElementById("processingresult");
    if (!dialogElem) return;

    const title = dialogElem.getAttribute('data-dialog-title');

    window.dialog.open({ elemId: 'processingresult', title: title })
}